<template>
    <el-drawer :with-header="false" size="900px" :visible="drawer">
        <div class="barcode-merge-detail" v-loading="loading">
            <div class="detail-header flex-box">
                <div class="header-code">箱条码:{{ barcodeNo }}</div>
                <div class="number-box flex-box">
                    <div
                        class="number-box-icon flex-box grey-bg"
                        @click="changeIndex(-1)">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div class="number-box-middle flex-box grey-bg">
                        <span class="blue-text">{{ currentIndex + 1 }}</span>
                        /{{ total }}
                    </div>
                    <div
                        class="number-box-icon flex-box grey-bg"
                        @click="changeIndex(1)">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <i class="el-icon-close close-icon" @click="close"></i>
            </div>
            <div class="detail-lebal-row flex-box">
                <div class="detail-lebal blue-text blue-bg">
                    工单号 {{ rowContentFactory(rowData.wipEntityName) }}
                </div>
                <div class="detail-lebal blue-text blue-bg">
                    实际柜号 {{ rowContentFactory(rowData.actContainerNo) }}
                </div>
                <!-- <div>装柜编码{{ data.wipEntityName || '--' }}</div>
                <div>柜序号{{ data.wipEntityName || '--' }}</div> -->
            </div>
            <div class="detail-lebal-row flex-box">
                <div class="detail-lebal grey-bg">
                    订单单号 {{ rowContentFactory(rowData.orderNo) }}
                </div>
                <div class="detail-lebal grey-bg">
                    订单生产编码 {{ rowContentFactory(rowData.productOrderNo) }}
                </div>
                <div class="detail-lebal grey-bg">
                    箱前缀 {{ rowContentFactory(rowData.boxingPrefix) }}
                </div>
                <div class="detail-lebal grey-bg">
                    出货通知书 {{ rowContentFactory(rowData.sourceBillNo) }}
                </div>
            </div>
            <div class="detail-context">
                <div class="sub-title flex-box">列表信息</div>
                <div class="context-card-box grey-bg">
                    <el-row class="row">
                        <el-col :span="12">
                            <span class="label">产品描述：</span>
                            <span class="value">{{
                                rowContentFactory(rowData.itemName)
                            }}</span>
                        </el-col>
                        <el-col :span="6">
                            <span class="label">出货状态：</span>
                            <span class="value">{{
                                rowContentFactory(rowData.shipStatus)
                            }}</span>
                        </el-col>
                        <el-col :span="6">
                            <span class="label">虚拟柜号：</span>
                            <span class="value">{{
                                rowContentFactory(rowData.virtualContainer)
                            }}</span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <span class="label">装柜仓库：</span>
                            <span class="value">{{
                                rowContentFactory(rowData.shiporgInvName)
                            }}</span>
                        </el-col>
                        <el-col :span="6">
                            <span class="label">装柜子库：</span>
                            <span class="value">{{
                                rowContentFactory(rowData.shipOrgName)
                            }}</span>
                        </el-col>
                        <el-col :span="6">
                            <span class="label">出货时间：</span>
                            <span class="value">{{
                                rowContentFactory(rowData.billDate)
                            }}</span>
                        </el-col>
                    </el-row>
                </div>
                <div class="context-card-box grey-bg box-msg flex-box">
                    <div class="box-msg-left flex-box">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            placement="top"
                            v-for="item in boxMsgLit"
                            :disabled="!item.tooltipShow"
                            :key="item.key"
                            :content="rowContentFactory(rowData[item.key])">
                            <div class="box-msg-tab">
                                <div class="label tab-row">
                                    {{ item.label }}
                                </div>
                                <div class="value no-warp">
                                    {{ rowContentFactory(rowData[item.key]) }}
                                </div>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="box-msg-right">
                        <img
                            :src="
                                require(`@/modules/sn/assets/images/box.png`)
                            " />
                        <div class="box-size box-length">
                            <div class="value tab-row">
                                {{ rowContentFactory(data.boxLength) }}
                            </div>
                            <div class="label">箱长(mm)</div>
                        </div>
                        <div class="box-size box-width">
                            <div class="value tab-row">
                                {{ rowContentFactory(data.boxWidth) }}
                            </div>
                            <div class="label">箱宽(mm)</div>
                        </div>
                        <div class="box-size box-height">
                            <div class="value tab-row">
                                {{ rowContentFactory(data.boxHeight) }}
                            </div>
                            <div class="label">箱高(mm)</div>
                        </div>
                    </div>
                </div>
                <div class="sub-title flex-box">明细信息</div>
                <template v-if="data.fourYardsInOneDetailRespList">
                    <div
                        class="context-card-box grey-bg"
                        v-for="(
                            item, index
                        ) in data.fourYardsInOneDetailRespList"
                        :key="index">
                        <el-row class="row">
                            <el-col :span="6">
                                <span class="label">物料编码：</span>
                                <span class="value blue-text">{{
                                    rowContentFactory(item.mitemCode)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">物料批次号：</span>
                                <span class="value blue-text">{{
                                    rowContentFactory(item.mitemLotNo)
                                }}</span>
                            </el-col>
                            <el-col :span="12">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    placement="top"
                                    :content="
                                        rowContentFactory(item.mitemDesc)
                                    ">
                                    <div class="no-warp">
                                        <span class="label">物料描述：</span>
                                        <span class="value">{{
                                            rowContentFactory(item.mitemDesc)
                                        }}</span>
                                    </div>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                        <el-row class="row">
                            <el-col :span="6">
                                <span class="label">物料品牌：</span>
                                <span class="value">{{
                                    rowContentFactory(item.mitemBrand)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">包装方式：</span>
                                <span class="value">{{
                                    rowContentFactory(item.packType)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">型号：</span>
                                <span class="value">{{
                                    item.materialModel === 'N/A'
                                        ? '--'
                                        : item.materialModel
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">是否是附件：</span>
                                <span class="value">{{
                                    rowContentFactory(
                                        attachmentFlagMap[item.attachmentFlag]
                                    )
                                }}</span>
                            </el-col>
                        </el-row>
                        <el-row class="row">
                            <el-col :span="6">
                                <span class="label">单位包装数：</span>
                                <span class="value">{{
                                    rowContentFactory(item.perQty)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">单位：</span>
                                <span class="value">{{
                                    rowContentFactory(item.itemUom)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">净重：</span>
                                <span class="value">{{
                                    rowContentFactory(item.netWeight)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">物料产地：</span>
                                <span class="value">{{
                                    rowContentFactory(item.mitemMadePlace)
                                }}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <span class="label">物料供应商：</span>
                                <span class="value">{{
                                    rowContentFactory(item.mitemSupplier)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">可用状态：</span>
                                <span class="value">{{
                                    item.state || '--'
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">IQC检验结果：</span>
                                <span class="value">{{
                                    rowContentFactory(item.mitemCheckResult)
                                }}</span>
                            </el-col>
                            <el-col :span="6">
                                <span class="label">ERP库存组织ID：</span>
                                <span class="value">{{
                                    rowContentFactory(item.organizationId)
                                }}</span>
                            </el-col>
                        </el-row>
                        <el-row
                            v-if="item.pqcPhotos && item.pqcPhotos.length > 0">
                            <div class="image-list-title">
                                PQC图片（{{ item.pqcPhotos.length }}）
                            </div>
                            <div class="image-list-container">
                                <div
                                    class="image-box"
                                    v-for="(
                                        imgItem, imgIndex
                                    ) in item.pqcPhotos"
                                    :key="imgIndex"
                                    @click="
                                        openViewer(item.pqcPhotos, imgIndex)
                                    ">
                                    <el-image
                                        style="width: 100px; height: 100px"
                                        :src="imgItem.photoFileName"
                                        fit="fill"></el-image>
                                </div>
                            </div>
                        </el-row>
                    </div>
                </template>
            </div>
        </div>
        <el-image-viewer
            v-if="showViewer"
            :on-close="closeViewer"
            :initialIndex="initialIndex"
            zIndex="9999"
            :url-list="viewUrl">
        </el-image-viewer>
    </el-drawer>
</template>

<script>
import { fourYardsInOneDetail } from '@/modules/sn/api/lcbsManagement.js';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
    components: {
        ElImageViewer
    },
    props: {
        barcodeNo: {
            type: String,
            default: () => ''
        },
        currentIndex: {
            type: Number,
            default: () => 0
        },
        total: {
            type: Number,
            default: () => 0
        },
        rowData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        stateDictList: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            data: {},
            drawer: false,
            loading: false,
            showViewer: false,
            viewUrl: [],
            initialIndex: 0,
            boxMsgLit: [
                {
                    label: '箱物料编码',
                    key: 'boxMitemCode'
                },
                {
                    label: '标贴类型',
                    key: 'boxType'
                },
                {
                    label: '包装模式',
                    key: 'packMode'
                },
                {
                    label: '包装内容',
                    key: 'packContent',
                    tooltipShow: true
                },
                {
                    label: '状态',
                    key: 'state'
                },
                {
                    label: '总净重(KG)',
                    key: 'totalNetWeight'
                },
                {
                    label: '总毛重(KG)',
                    key: 'totalGrossWeight'
                }
            ],
            attachmentFlagMap: {
                N: '否',
                Y: '是'
            }
        };
    },
    watch: {
        barcodeNo: {
            handler(newval) {
                this.getData(newval);
            }
        }
    },
    computed: {
        _barcodeNo: () => {
            return this.barcodeNo;
        }
    },
    methods: {
        open(barcodeNo) {
            this.drawer = true;
            // this.getData(barcodeNo);
        },
        close() {
            this.drawer = false;
        },
        rowContentFactory(value, code) {
            let content = '--';
            if (value) {
                content = value + '';
                if (code) content = value + '(' + code + ')';
            }
            return content;
        },
        getData(barcodeNo) {
            this.loading = true;
            fourYardsInOneDetail({ barcodeNo: barcodeNo, pictureFormat: 1 })
                .then((res) => {
                    if (res.code + '' === '0' && res.data) {
                        this.data = res.data;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        changeIndex(num) {
            const newIndex = this.currentIndex + num;
            if (newIndex < 0 || newIndex >= this.total) {
                return false;
            } else {
                this.$emit('changeIndex', newIndex);
            }
        },
        openViewer(data, index) {
            this.viewUrl = data.map((item) => item.photoFileName);
            this.initialIndex = index;
            this.showViewer = true;
        },
        closeViewer() {
            this.viewUrl = [];
            this.initialIndex = 0;
            this.showViewer = false;
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge-detail {
    box-sizing: border-box;
    padding: 22px;
    height: 100vh;
    overflow: auto;
    font-size: 12px;
}
.grey-bg {
    background: #f5f5f5;
    border-radius: 4px;
    color: #666666;
}
.blue-bg {
    background: #4285f519;
    border-radius: 4px;
}
.lebal {
    color: #888888;
}
.value {
    color: #000;
}
.no-warp {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.blue-text {
    color: #4285f5;
}
.flex-box {
    display: flex;
    align-items: center;
}
.context-card-box {
    align-items: flex-start;
    margin-top: 8px;
    padding: 16px;
}
.row {
    margin-bottom: 10px;
}
.tab-row {
    margin-bottom: 4px;
}

.detail-header {
    position: relative;
    .header-code {
        margin-right: 20px;
        font-size: 18px;
        color: #333333;
        font-weight: 600;
    }
    .number-box-middle {
        font-size: 12px;
        margin: 0 8px;
        padding: 0 15px;
        height: 30px;
    }
    .number-box-icon {
        justify-content: center;
        height: 30px;
        width: 30px;
        font-size: 18px;
        font-weight: 600;
        &:hover {
            color: #4285f5;
        }
    }
    .close-icon {
        position: absolute;
        right: 0;
        font-size: 20px;
        &:hover {
            color: #4285f5;
        }
    }
}
.detail-lebal-row {
    font-size: 14px;
    flex-wrap: wrap;
    .detail-lebal {
        margin-top: 10px;
        margin-right: 10px;
        padding: 5px;
    }
}
.sub-title {
    margin-top: 20px;
    font-weight: 500;
    font-size: 16px;
    &::after {
        content: '';
        display: block;
        flex: 1;
        margin-left: 10px;
        height: 1px;
        background: #e9e9e9;
    }
}
.box-msg {
    .box-msg-left {
        flex: 1;
        flex-wrap: wrap;
        align-items: flex-start;
    }
    .box-msg-tab {
        box-sizing: border-box;
        margin-right: 10px;
        padding: 8px;
        width: 130px;
        background-color: #fff;
        &:nth-child(1) {
            margin-bottom: 10px;
        }
    }
    .box-msg-right {
        margin-top: 20px;
        margin-right: 20px;
        position: relative;
        text-align: right;
        // flex: 2;
        width: 200px;
        img {
            width: 150px;
        }
    }
    .box-size {
        position: absolute;
        text-align: left;
        white-space: nowrap;
    }
    .box-length {
        left: 90px;
    }
    .box-width {
        top: 55px;
        left: 170px;
    }
    .box-height {
        top: 15px;
        left: -10px;
    }
}
.image-list-title {
    margin-top: 10px;
    color: #000;
    font-weight: bold;
}
.image-list-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin-top: 10px;
    overflow: scroll;
    .image-box {
        margin-right: 10px;
        border: 1px solid #e9e9e9;
    }
}
</style>
